import { curry } from 'lib/util'

/**
 * Open QR Code Event Handler
 *
 * Requests the QR code image from the server and opens it in a new tab.
 *
 * @param module    the application module specification
 * @param component the component specification
 * @param event     the platform event
 */
const openQRCode = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const httpAdapter = module[G.MODEL][G.ADAPTER][G.HTTP]
  const { licence: model = {} } = module[G.MODEL][G.CHILDREN] || {}
  const valueCache = model[G.CACHE]?.value || {}

  try {
    const result = await httpAdapter.post({ url: '/api/v1/qrcode',
      params: {
        content: {
          serial: valueCache.serial,
          duration_months: valueCache.duration,
          license_counter: valueCache.counter,
          signature: valueCache.licenseKey,
        },
      } })
    const objectUrl = result && URL.createObjectURL(result)

    await module[G.ADAPTER][G.ROUTER].newTab({ url: objectUrl })
  } catch (e) {
    console.error('Could not open QR Code', e)
  }
}

export default curry(openQRCode)
